import { apiUpload } from './client';

export interface UploadedImage {
  url: string;
}

/**
 * Tải ảnh thương hiệu lên bucket đọc công khai (`S7-BE-06`). Server xác thực magic bytes + dung
 * lượng rồi trả URL ổn định để lưu vào ô `*_image_url`.
 */
export const mediaApi = {
  uploadImage: (file: File): Promise<UploadedImage> => {
    const formData = new FormData();
    formData.append('file', file);
    return apiUpload<UploadedImage>('/admin/media/images', formData);
  },
};
